var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "mb-5"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('div', [_vm._l(_vm.groups, function (group) {
    return _vm.refundRequestsGrouped[group.identifier] ? _c('div', {
      staticClass: "mt-3 mb-5"
    }, [_c('h4', {
      staticClass: "mb-4"
    }, [_vm._v(_vm._s(group.display_name))]), _vm._l(_vm.refundRequestsGrouped[group.identifier], function (refundRequest) {
      return _c('refund-request', {
        key: refundRequest.id,
        attrs: {
          "refund-request": refundRequest
        },
        on: {
          "changed": _vm.changed
        }
      });
    })], 2) : _vm._e();
  }), _vm.refundRequestsGrouped['other'] ? _c('div', [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("Overige")]), _vm._l(_vm.refundRequestsGrouped['other'], function (refundRequest) {
    return _c('refund-request', {
      key: refundRequest.id,
      attrs: {
        "refund-request": refundRequest
      },
      on: {
        "changed": _vm.changed
      }
    });
  })], 2) : _vm._e(), !_vm.refundRequests.length ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(" Geen crediteringen voor deze order ")]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }